import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from '../pages/Home/Home';
import Footer from '../share module/Footer/Footer';
import Header from '../share module/Header/Header';
import Registration from '../pages/Registration/Registration';
import Login from '../pages/Login/Login';
import CreateProduct from '../pages/CRUD/CreateProduct';
import ProductList from '../pages/CRUD/ProductList';
import EditProduct from '../pages/CRUD/EditProduct';
import Profile from '../pages/Profile/Profile';
import { useSelector } from 'react-redux';
import About from '../pages/About/About';
import Contact from '../pages/Contact/Contact';
const PrivateRoute = ({ element }) => {
    const { isLoggedIn } = useSelector((state) => state.authKey)
    const isAuthenticated = isLoggedIn;
    return isAuthenticated ? element : <Navigate to="/login" />;
};

function Routing() {
    const publicRouting = [
        {
            path: "/home",
            element: <Home />
        },
        {
            path: "/about-us",
            element: <About />
        },
        {
            path: "/contact-us",
            element: <Contact />
        },
        {
            path: "/registration",
            element: <Registration />
        },
        {
            path: "/",
            element: <Login />
        },
    ];
    const privateRouting = [
        {
            path: "/create-product",
            element: <CreateProduct />
        },
        {
            path: "/product-list",
            element: <ProductList />
        },
        {
            path: "/edit-product/:id",
            element: <EditProduct />
        },
        {
            path: "/profile",
            element: <Profile />
        },
    ]
    return (
        <Router>
            <Header />
            <Routes>

                {
                    publicRouting.map((item) => {
                        return <Route path={item.path} element={item.element} />
                    })
                }
                {
                    privateRouting.map((item) => {
                        return <Route  path={item.path} element={<PrivateRoute element={item.element} />} />
                    })
                }
                
            </Routes>
            <Footer />
        </Router>
    );
}

export default Routing;
